import React from "react";
import Slider from "react-slick";
import theme from "../Theme";

const bgImg = "/assets/testybg.png"
 const reviewsData = [
  {
    id: 1,
    name: "Filiberto",
    review:
      "The organic chicken breast was extremely fresh and tender. Delivery was on time, and the packaging kept everything cool. Will definitely order again!",
    avatar: "/assets/avatar.png",
    rating: 5,
  },
  {
    id: 2,
    name: "Lana",
    review:
      "Amazing quality! The mutton was juicy and fresh. Love the quick delivery.",
    avatar: "/assets/avatar.png",
    rating: 4,
  },
];
const Reviews = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <section
      className="review-section"
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "80px 0",
        overflow:"hidden"
      }}
    >
      <div className="text-center text-white mb-5">
        <h2 className="fw-bold">“What Our Customer Says”</h2>
      </div>
      <div className="container">
        <Slider {...settings} >
          {reviewsData.map((item) => (
            <div key={item.id}>
              <div className="review-card mx-auto text-center p-5 d-flex flex-column justify-content-center align-items-center" style={{backgroundColor:theme.color.whi, borderRadius:"10px", maxWidth:"600px",maxHeight:"300px"}}>
                <p className="mb-4 text-dark fs-5">"{item.review}"</p>
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="rounded-circle mb-2"
                  style={{ width: "60px", height: "60px", objectFit: "cover" }}
                />
                <h5 className="fw-bold mb-2">{item.name}</h5>
                <div className="text-danger fs-5">
                  {"★".repeat(item.rating)}{"☆".repeat(5 - item.rating)}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Reviews;
